function contestStatusError() {
  const consentCheckbox = document.getElementById('contest_consent');
  const resultConsentCheckbox = document.getElementById('contest_result_consent');
  const btnSubmit = document.getElementById('publication_contest');
  const errorsBlock = document.querySelector('.error-messages');
  const statusErrorBlock = document.querySelector('#status-error');

  if (!btnSubmit) {
    return;
  }

  btnSubmit?.addEventListener('click', (e) => {
    if (statusErrorBlock) {
      e.preventDefault();

      const navbarHeight = document.querySelector('.navbar').offsetHeight;
      const statusErrorBlockHeight = statusErrorBlock.offsetHeight;
      statusErrorBlock.scrollIntoView(false);

      return;
    }

    let hasErrors = false;
    let errorsElements = '';

    if (consentCheckbox && !consentCheckbox.checked) {
      errorsElements = '<div class="mb-3">Для публикации конкурса необходимо подтвердить согласие с офертой</div>';
      hasErrors = true;
    }

    if (resultConsentCheckbox && !resultConsentCheckbox.checked) {
      errorsElements = errorsElements + '<div>Для публикации конкурса необходимо подтвердить согласие с размещением результатов конкурса</div>';
      hasErrors = true;
    }

    if (hasErrors) {
      e.preventDefault();
      errorsBlock.innerHTML = errorsElements;
    }
  });
}

export { contestStatusError };